import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { TranslateModule } from '@ngx-translate/core';

import { DateAngularModule } from 'rev-shared/date/DateAngular.Module';

import { VideoChaptersContainerComponent } from './VideoChaptersContainer.Component';

@NgModule({
	declarations: [
		VideoChaptersContainerComponent
	],
	imports: [
		CommonModule,
		DateAngularModule,
		TranslateModule
	],
	exports: [
		VideoChaptersContainerComponent
	]
})
export class VideoChaptersModule { }
